import { ActionTree } from 'vuex/types/index'
import { RootState } from '~/store/store.types'
import { SohoModel } from '~/constants/SohoModel'
import { InquiryResource, InquiryState, UserInquiry } from './inquiries.types'

const actions: ActionTree<InquiryState, RootState> = {
  async fetchInquiry({ commit }) {
    const { data } = await this.$sohoApi.get<InquiryResource>(SohoModel.InquiryType)

    if (data) {
      commit('SET_INQUIRIES', { data })
    }
  },

  async createInquiry(_, { message, token }) {
    await this.$sohoApi.post<UserInquiry>(SohoModel.Inquiry, message, {
      Accept: "application/vnd.api-v2+json",
      "X-Sh-Recaptcha-Response": token
    })
  }
}

export default actions
